import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function VolumeOverTime({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    return (
        <ChartSection id="volume-time" title="Congressional trading volume over time" subtitle="Monthly trade count — are they trading more or less than before?">
            <Box sx={{ height: 300 }}>
                <ResponsiveBar
                    data={data} keys={['trades']} indexBy="month"
                    margin={{ top: 10, right: 20, bottom: 50, left: 45 }}
                    padding={0.15} borderRadius={1} enableLabel={false}
                    colors={[colors.primary + '80']}
                    axisBottom={{ tickRotation: 45, tickValues: data.filter((_, i) => i % 12 === 0).map(d => d.month) }}
                    axisLeft={{ legend: 'Trades', legendPosition: 'middle', legendOffset: -35 }}
                    tooltip={({ data: d, color }) => (
                        <ChartTooltip
                            title={d.month}
                            rows={[{ label: 'Trades', value: d.trades.toLocaleString(), color }]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
